<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>What type of device is it?</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-grid grid-col-2 row">
                            <div class="selectable-card"
                                 v-for="type in types"
                                 :key="type.id"
                                 @click="selectType(type)"
                                 :class="{'active': typeIsActive(type)}">
                                <div class="card-body">
                                    <div class="card-img device-type">
                                        <!-- TODO: This images have been hardcoded as type.image.path points to the old images in the DB. Remove the hardcoded images once all images have been migrated to the new AWS bucket -->
                                        <img class="logo" v-if="type.code === 'phone'" src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/devices/phone.svg" :alt="type.title">
                                        <img class="logo" v-if="type.code === 'tablet'" src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/devices/tablet.svg" :alt="type.title">
        <!--                                <img class="logo" :src="type.image.path" :alt="type.title">-->
                                    </div>
                                    <p>
                                        {{ type.title }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: prevStep }" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <router-link :to="{ name: 'deviceModel'}" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !typeHasBeenSelected}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "DeviceType",

        mounted() {
            this.checkCanBeOnPage();
            this.loadMakes();
        },

        computed: {
            ...mapGetters([
                'carrierDetails',
                'makeHasBeenSelected',
                'types',
                'typeHasBeenSelected',
                'typeIsActive',
                'onlyOfferSamsung'
            ]),

            prevStep() {
                if (this.onlyOfferSamsung) {
                    return 'postcodeSearch';
                }

                return 'deviceMake';
            }
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'loadMakes',
                'selectType'
            ]),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.makeHasBeenSelected) {
                        this.$router.push({name: this.prevStep})
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>